import { CheckCircle, Clock, X } from 'lucide-react';
import { Button, cn } from '@sandtech-hub-monorepo/ui-kit';
import { AppealStatus } from '@sandtech-hub-monorepo/ehub-client';

interface Props {
  appealStatus: AppealStatus;
  onViewDetails: () => void;
}

export const AppealStatusBanner = ({ appealStatus, onViewDetails }: Props) => {
  const isPending = appealStatus === AppealStatus.Pending;
  const isApproved = appealStatus === AppealStatus.Approved;
  const isDenied = appealStatus === AppealStatus.Denied;

  if (!isPending && !isApproved && !isDenied) {
    return null;
  }

  const label = isPending
    ? 'Appeal in Review'
    : isApproved
    ? 'Appeal Successful'
    : 'Appeal was unsuccessful';

  return (
    <div
      className={cn(
        'px-4 py-2 flex flex-col sm:flex-row gap-2 lg:gap-4 items-center border w-full rounded-lg text-sm',
        isPending ? 'border-info bg-info/10 text-info' : '',
        isApproved ? 'border-success bg-success/10 text-success' : '',
        isDenied ? 'border-destructive bg-destructive/10 text-destructive' : ''
      )}
    >
      {isPending && <Clock className="shrink-0 h-6 w-6" />}
      {isApproved && <CheckCircle className="shrink-0 h-6 w-6" />}
      {isDenied && <X className="shrink-0 h-6 w-6" />}
      <span className="flex-1 font-semibold">{label}</span>
      <Button
        variant="link"
        className={cn(
          'h-fit p-0 text-sm font-semibold underline shrink-0 sm:ml-auto',
          isPending ? 'text-info' : '',
          isApproved ? 'text-success' : '',
          isDenied ? 'text-destructive' : ''
        )}
        onClick={onViewDetails}
      >
        View Details &gt;
      </Button>
    </div>
  );
};
